/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalPostAutomatedRolloutConfigStartPathParams = NonNullable<
  operations['internalPostAutomatedRolloutConfigStart']['parameters']['path']
>;

export type InternalPostAutomatedRolloutConfigStartRequestBody = OperationRequestBodyContent<
  operations['internalPostAutomatedRolloutConfigStart']
>;

export interface Input extends InternalPostAutomatedRolloutConfigStartPathParams {
  apiVersion?: string;
  body: InternalPostAutomatedRolloutConfigStartRequestBody;
}

export async function internalPostAutomatedRolloutConfigStart(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/automated-rollout-configs/{id}/start', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
